var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payout-detail-modal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("components.detail"),
            visible: _vm.dialogTableVisible,
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
            open: _vm.getDetailInfo,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          [
            _c("div", { staticClass: "total" }, [
              _c("div", { staticClass: "total-item" }, [
                _c("div", { staticClass: "total-title" }, [
                  _vm._v(_vm._s(_vm.$t("data.sell_amount")) + ":"),
                ]),
                _c("div", { staticClass: "total-num" }, [
                  _vm._v(
                    _vm._s(_vm.merchantInfo.sell_currency) +
                      " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(_vm.merchantInfo.sell_amount)
                      )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "line" }),
              _c("div", { staticClass: "total-item" }, [
                _c("div", { staticClass: "total-title" }, [
                  _vm._v(_vm._s(_vm.$t("data.buy_amount")) + ":"),
                ]),
                _c("div", { staticClass: "total-num" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.merchantInfo.buy_currency) +
                      " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(_vm.merchantInfo.buy_amount)
                      )
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "total" }, [
              _c("div", { staticClass: "total-item" }, [
                _c("div", { staticClass: "total-title" }),
                _c("div", { staticClass: "total-num" }),
              ]),
            ]),
          ],
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.timeline")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.create_time"))),
            ]),
            _c("span", { staticClass: "content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.complete_time"))),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c(
              "span",
              { staticClass: "item-left", staticStyle: { color: "#4B5567" } },
              [_vm._v(_vm._s(_vm.merchantInfo.create_date_time))]
            ),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.complete_date_time)),
            ]),
          ]),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.description")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(" " + _vm._s(_vm.$t("data.fee")) + ":"),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(_vm.merchantInfo.foreign_exchange_fee_split_currency) +
                  " " +
                  _vm._s(
                    _vm._f("toDivideWithDot")(
                      _vm.merchantInfo.foreign_exchange_fee_split
                    )
                  )
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.exchange_rate"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.exchange_rate)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.quote_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.quote_id)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.quote_time"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.quote_time)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.quote_expiry_time"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.quote_expire_time)),
            ]),
          ]),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.related_transactions")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.transaction_type"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(
                  _vm.getTransactionTypeMap(
                    _vm.merchantInfo.related_transaction.transaction_type
                  ).label
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.transaction_id"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(_vm.merchantInfo.related_transaction.transaction_id)
              ),
            ]),
          ]),
          _vm.$store.getters.nsdsStatus
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("merchantAccount.nsds_payment_amount"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.merchantInfo.foreign_exchange_fee_split_currency
                    ) +
                      " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(
                          _vm.merchantInfo.related_transaction.nsds_pay_amount
                        )
                      )
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.document_proof")) + " "),
          ]),
          _vm._l(_vm.merchantInfo.proof_files, function (item) {
            return _c(
              "div",
              { key: item.id, staticStyle: { "margin-bottom": "10px" } },
              [
                _c(
                  "div",
                  { staticClass: "content-blue" },
                  [
                    _vm.isImg(item.file_name)
                      ? _c("el-image", {
                          staticStyle: { height: "150px" },
                          attrs: {
                            src: item.file_url,
                            "preview-src-list": [item.file_url],
                          },
                        })
                      : _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onClickFile(item.file_url)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.file_name))]
                        ),
                  ],
                  1
                ),
              ]
            )
          }),
          _c(
            "el-tag",
            {
              staticClass: "payout-status tag-custom",
              attrs: {
                type: _vm.getFxTransactionStatusMap(_vm.merchantInfo.status)
                  .type,
                "min-width": "150",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.getFxTransactionStatusMap(_vm.merchantInfo.status).label
                  )
              ),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }